import { useEffect, useRef, useState } from "react";
import RightModal from "../../../components/Modal/RightModal";
import SavedFilterComponent from "../../../components/SavedFilters/SavedFilterComponent";
import { initialContractCloseFilterData } from "../../../utils/initialData";
import { handleDropdownClose } from "../../../utils/utils";
import ContractCloseFilterData from "./ContractCloseFilterData";

const ContractCloseFilter = ({
  filterData,
  activeTab,
  onSetFilterData,
  onCallApiAgain,
  from,
}) => {
  const dropdownRef = useRef(null);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  const [selectedSavefilterId, setSelectedSaveFilterId] = useState(() => {
    const id = localStorage.getItem("selectedSavefilterId");
    return id ? id : "";
  });

  // ✅ CLEAN FILTER DATA (REMOVE LABELS + EMPTY VALUES)
  const getCleanFilterData = (data) => {
    const cleaned = {};

    Object.keys(data || {}).forEach((key) => {
      if (
        !key.endsWith("_label") &&
        data[key] !== "" &&
        data[key] !== null &&
        data[key] !== undefined
      ) {
        cleaned[key] = data[key];
      }
    });

    return cleaned;
  };

  // ✅ CORRECT COUNT
  const getFilterCount = (data) => {
    return Object.keys(getCleanFilterData(data)).length;
  };

  const count = getFilterCount(filterData);

  useEffect(() => {
    const handleClose = () => {
      setIsSidebarOpen(false);
    };
    handleDropdownClose(dropdownRef, handleClose);
  }, []);

  const handleFilter = () => {
    const cleanedData = getCleanFilterData(filterData);

    localStorage.setItem("filterData", JSON.stringify(cleanedData));
    onCallApiAgain(cleanedData);

    setIsSidebarOpen(false);
    setSelectedSaveFilterId("");
  };

  const handleFilterChange = (value, name) => {
    onSetFilterData({ ...filterData, [name]: value });
  };

  const handleSelectFilter = (value) => {
    const dataToSet = {
      current_phase: value?.current_phase || "",
      current_phase_label: value?.current_phase_label || "",
      next_action: value?.next_action || "",
      next_action_label: value?.next_action_label || "",
      advisor: value?.advisor || "",
      created_start_date: value?.created_start_date,
      created_end_date: value?.created_end_date,
      created_at: value?.created_at,
      status: value?.status,
    };

    localStorage.setItem("filterData", JSON.stringify(dataToSet));
    onSetFilterData(dataToSet);
    onCallApiAgain(getCleanFilterData(dataToSet));
  };

  const saveSearchFilterData = {
    current_phase: filterData?.current_phase,
    next_action: filterData?.next_action,
    advisor: filterData?.advisor,
    created_start_date: filterData?.created_start_date,
    created_end_date: filterData?.created_end_date,
    created_at: filterData?.created_at,
    status : filterData?.status,
  };

  return (
    <div>
      <SavedFilterComponent
        from={from}
        count={count}
        isSidebarOpen={isSidebarOpen}
        saveSearchFilterData={saveSearchFilterData}
        selectedSavefilterId={selectedSavefilterId}
        initialFilterData={initialContractCloseFilterData}
        onCallApiAgain={onCallApiAgain}
        onSetFilterData={onSetFilterData}
        onSetSelectedSaveFilterId={(value) => {
          setSelectedSaveFilterId(value);
        }}
        handleSelectFilter={handleSelectFilter}
        onSetIsSidebarOpen={(value) => setIsSidebarOpen(value)}
      />

      <RightModal
        isOpen={isSidebarOpen}
        onClose={() => {
          setIsSidebarOpen(false);
          onSetFilterData(initialContractCloseFilterData);
        }}
        ref={dropdownRef}
        title={"Filter"}
        from={from}
        desc={`Enter Contract To Close information.`}
        onFilter={handleFilter}
        saveSearchFilterData={saveSearchFilterData}
        onSetSelectedSaveFilterId={(value) =>
          setSelectedSaveFilterId(value)
        }
      >
        <ContractCloseFilterData
          isSidebarOpen={isSidebarOpen}
          filterData={filterData}
          activeTab={activeTab}
          handleFilterChange={handleFilterChange}
          onSetFilterData={onSetFilterData}
        />
      </RightModal>
    </div>
  );
};

export default ContractCloseFilter;